import type { OpportunitySignals } from '../services/signalsService'

export type EntryRangeInfo = {
  hasEntryRange: boolean
  entryFrom: number | null
  entryTo: number | null
  entryMid: number | null
}

export function computeEntryRangeInfo(signals: OpportunitySignals | null): EntryRangeInfo {
  if (!signals) {
    return {
      hasEntryRange: false,
      entryFrom: null,
      entryTo: null,
      entryMid: null,
    }
  }

  const { side, entryMin, entryMax } = signals

  const hasEntryRangeRaw = entryMin != null && entryMax != null
  if (!hasEntryRangeRaw) {
    return {
      hasEntryRange: false,
      entryFrom: null,
      entryTo: null,
      entryMid: null,
    }
  }

  let entryFrom: number
  let entryTo: number

  if (side === 'long') {
    entryFrom = Math.max(entryMin!, entryMax!)
    entryTo = Math.min(entryMin!, entryMax!)
  } else {
    entryFrom = Math.min(entryMin!, entryMax!)
    entryTo = Math.max(entryMin!, entryMax!)
  }

  const entryMid = (entryFrom + entryTo) / 2

  return {
    hasEntryRange: true,
    entryFrom,
    entryTo,
    entryMid,
  }
}

export function isPriceInEntryRange(info: EntryRangeInfo, price: number | null): boolean {
  if (!info.hasEntryRange || info.entryFrom == null || info.entryTo == null) return false
  if (price == null) return false
  const zoneMin = Math.min(info.entryFrom, info.entryTo)
  const zoneMax = Math.max(info.entryFrom, info.entryTo)
  return price >= zoneMin && price <= zoneMax
}

